import { default as Enumerable } from "linq";
import {
  ExtendedRouteConfig,
  AbstractRoutesFactory,
  Dispatcher,
  RoutesFactory as BaseRoutesFactory,
} from "../../base/routing";
import {
  Home,
  ErrorView,
} from "../components";
import {
  FormatListView,
  EditHistoryView,
  NewFormatEditView,
  FormatEditView,
  NewCopiedFormatEditView,
  FormatView,
  UnsynchronizedFormatListView,
} from "../components/format";
import {
  PdfFileView,
  EmbeddedEditableFormatSummariesTreeSelectorView,
} from "../../documaker/components/document";
import {
  NewDocumentView,
} from "../components/document";
import { Query } from "./Query";

export class RoutesFactory extends AbstractRoutesFactory<Query, Dispatcher<Query>> {
  constructor(dispatcher: Dispatcher<Query>) {
    super(dispatcher);
  }

  create(): ExtendedRouteConfig[] {
    const baseFactory = new BaseRoutesFactory(this._dispatcher);
    return Enumerable.from(baseFactory.create())
      .select(r => this.hook(r))
      .toArray()
      .concat([
        {
          path: "/",
          name: "メインメニュー",
          component: Home,
          meta: { requiresAuth: true }
        },
        {
          path: "/ShowFormatList",
          name: "フォーマット一覧",
          component: FormatListView,
          meta: { requiresAuth: true }
        },
        {
          path: "/ShowEditHistory",
          name: "編集履歴",
          component: EditHistoryView,
          meta: { requiresAuth: true }
        },
        {
          path: "/EditNewFormat",
          name: "フォーマット新規作成",
          component: NewFormatEditView,
          meta: { requiresAuth: true },
        },
        {
          path: "/EditFormat",
          name: "フォーマット編集",
          component: FormatEditView,
          meta: { requiresAuth: true },
          props: r => this.toProps(r, q => ({
            formatId: q.formatId,
          })),
        },
        {
          path: "/ShowUnsynchronizedFormatList",
          name: "未同期フォーマットリスト",
          component: UnsynchronizedFormatListView,
          meta: { requiresAuth: true },
        },
        {
          path: "/EditNewCopiedFormat",
          name: "フォーマットコピー",
          component: NewCopiedFormatEditView,
          meta: { requiresAuth: true },
          props: r => this.toProps(r, q => ({
            sourceFormatId: q.formatId,
            sourceArchiveId: q.archiveId,
          })),
        },
        {
          path: "/PreviewNewDocument",
          name: "文書編集プレビュー",
          component: NewDocumentView,
          meta: { requiresAuth: true },
          props: r => this.toProps(r, q => ({
            patientNo: q.patientNo,
            formatId: q.formatId,
            archiveId: q.archiveId,
          })),
        },
        {
          path: "/PreviewNewTemporaryDocument",
          name: "編集中文書プレビュー",
          component: NewDocumentView,
          meta: { requiresAuth: true },
          props: r => this.toProps(r, q => ({
            patientNo: q.patientNo,
            formatId: q.formatId,
            archiveId: q.archiveId,
          })),
        },
        {
          path: "/ShowFormat",
          name: "フォーマット参照",
          meta: { requiresAuth: true },
          component: FormatView,
          props: r => this.toProps(r, q => ({
            formatId: q.formatId,
            archiveId: q.archiveId,
            shouldNotifyRegistered: q.shouldNotifyRegistered,
            isTemporary: q.isTemporary,
          })),
        },
        {
          path: "/ShowDocumentSimply",
          name: "文書表示",
          component: PdfFileView,
          meta: { requiresAuth: true },
          props: r => this.toProps(r, q => ({
            label: q.label,
            name: q.name,
            encodedUri: q.encodedUri,
            isPrintable: q.isPrintable,
            forceEnableOpenTypeFontFace: q.forceEnableOpenTypeFontFace,
          }))
        },
        {
          path: "/Embedded/SelectFolder",
          name: "フォルダ選択(埋込)",
          component: EmbeddedEditableFormatSummariesTreeSelectorView,
          meta: { requiresAuth: true },
        },
      ]);
  }

  private hook(route: ExtendedRouteConfig): ExtendedRouteConfig {
    if (route.path === "/Error") {
      return   {
        path: "/Error",
        name: "エラー",
        component: ErrorView,
        props: r => this.toProps(r, q => ({
          url: q.url,
          message: q.message,
        }))
      };
    }
    return route;
  }
}
